import {skipToken} from '@reduxjs/toolkit/query';

import {isNil} from 'ramda';
import {isNotNilOrEmpty} from 'ramda-adjunct';

import {type OrderActions, useGetOrderActionsQuery} from '@dms/api/workshop';

interface UseOrderActionsProps {
  serviceCaseId: string;
  serviceOrderId: string;
  embeddedOrderActions: OrderActions;
}

export function useOrderActions(props: UseOrderActionsProps) {
  const shouldFetchGranularActions =
    isNil(props.embeddedOrderActions) &&
    isNotNilOrEmpty(props.serviceCaseId) &&
    isNotNilOrEmpty(props.serviceOrderId);

  const granularQuery = useGetOrderActionsQuery(
    shouldFetchGranularActions
      ? {serviceCaseId: props.serviceCaseId, serviceOrderId: props.serviceOrderId}
      : skipToken
  );

  return {
    orderActions: props.embeddedOrderActions ?? granularQuery.data?.orderActions,
    isLoading: granularQuery.isLoading,
    isError: granularQuery.isError,
  };
}
